import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { apiAction } from '../../store/generalSlice';

const AddChecker = ({ condition, subCondition }) => {
  const [checkerName, setCheckerName] = useState('');
  const dispatch = useDispatch();

  const handleAddChecker = () => {
    if (checkerName.trim() === '') return;
    const updatedSubConditions = condition.subConditions.map((sc) => {
      if (sc._id === subCondition._id) {
        return {
          ...subCondition,
          checkers: Array.isArray(subCondition.checkers)
            ? [...subCondition.checkers, { name: checkerName }]
            : [{ name: checkerName }],
        };
      }
      return sc;
    });
    dispatch(
      apiAction({
        reduxField: 'condition',
        route: 'conditions/updateSubConditions',
        conditionId: condition._id,
        subConditions: updatedSubConditions,
      })
    );

    setCheckerName('');
  };

  return (
    <div className='add-checker btn-group-vertical'>
      <input
        type='text'
        className='form-control'
        value={checkerName}
        onChange={(e) => setCheckerName(e.target.value)}
        placeholder='Enter checker name'
      />
      <button className='btn btn-outline-primary' onClick={handleAddChecker} disabled={!checkerName}>
        Add Checker
      </button>
    </div>
  );
};

export default AddChecker;
